export const getRandomInt = (to) => {
  return Math.floor(Math.random() * (to + 1));
};
